export interface Workflow {
  id: number
  name: string
  path: string
  routePath?: string
  state:
    | 'active'
    | 'disabled_fork'
    | 'disabled_inactivity'
    | 'disabled_manually'
    | 'disabled_admin'
    | 'deleted'
    | 'unknown'
}

/**
 * A workflow's `name:` key is optional in YAML, and the server stores a missing one as an empty
 * string rather than deriving a fallback. Searching by path surfaces those workflows, so fall back
 * to the file name to keep links and pin buttons labelled.
 */
export function workflowDisplayName(workflow: Pick<Workflow, 'name' | 'path'>): string {
  if (workflow.name) return workflow.name
  return workflow.path.split('/').pop() || workflow.path
}

export interface BannersPayload {
  enablePath: string
}
